/**
 * cn — conditional className merge.
 *
 * Combines clsx (conditional class joining) with tailwind-merge (dedupes
 * conflicting Tailwind utilities, e.g. "px-2 px-4" -> "px-4"). Standard helper
 * across React/Tailwind codebases.
 *
 * Usage:
 *   cn("px-4 py-2", isActive && "bg-accent", className)
 */
import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
